export default "__VITE_ASSET__NHpbjFct__"